interface IntroPhotosScreenProps {
  onNext: () => void;
}

export default function IntroPhotosScreen({ onNext }: IntroPhotosScreenProps) {
  const photos = [
    {
      url: '/images/onboarding/intro-mountains.jpg',
      rotate: '-8deg', translateX: '-30px', translateY: '10px', opacity: 0.7, zIndex: 1,
    },
    {
      url: '/images/onboarding/intro-ocean.jpg',
      rotate: '4deg', translateX: '18px', translateY: '0px', opacity: 0.85, zIndex: 2,
    },
    {
      url: '/images/onboarding/intro-street.jpg',
      rotate: '0deg', translateX: '0px', translateY: '0px', opacity: 1, zIndex: 3,
    },
  ];

  return (
    <div
      className="flex flex-col w-full h-screen"
      style={{
        background: 'linear-gradient(170deg, #1A1B2E 0%, #2D1B3D 60%, #1F1A35 100%)',
        overflowY: 'auto',
        overflowX: 'hidden',
        WebkitOverflowScrolling: 'touch',
      }}
    >
      {/* Progress dots */}
      <div className="flex justify-center gap-2 pt-12 pb-4">
        {[0, 1, 2, 3].map((i) => (
          <div
            key={i}
            style={{
              width: i === 3 ? '20px' : '6px', height: '6px',
              borderRadius: '3px',
              background: '#3ECFA0',
            }}
          />
        ))}
      </div>

      {/* Stacked photos */}
      <div
        className="flex-1 flex items-center justify-center"
        style={{ position: 'relative' }}
      >
        <div style={{ position: 'relative', width: '200px', height: '260px' }}>
          {photos.map((p, i) => (
            <div
              key={i}
              style={{
                position: 'absolute',
                top: 0, left: 0,
                width: '200px', height: '260px',
                borderRadius: '20px',
                overflow: 'hidden',
                transform: `rotate(${p.rotate}) translateX(${p.translateX}) translateY(${p.translateY})`,
                opacity: p.opacity,
                zIndex: p.zIndex,
                border: '6px solid rgba(255,255,255,0.9)',
                boxShadow: '0 12px 40px rgba(0,0,0,0.4)',
              }}
            >
              <img src={p.url} alt="" className="w-full h-full object-cover object-top" />
            </div>
          ))}
        </div>
      </div>

      {/* Text */}
      <div className="px-8 pb-4">
        <p style={{ fontSize: '16px', fontWeight: 400, color: '#A8B2C8', lineHeight: 1.7, textAlign: 'center' }}>
          Вы также можете добавлять фотографии к воспоминаниям, чтобы делать их ещё ярче и живее.
        </p>
      </div>

      {/* Button */}
      <div
        className="px-7 pt-2"
        style={{ paddingBottom: 'calc(32px + env(safe-area-inset-bottom))' }}
      >
        <button
          onClick={onNext}
          className="w-full active:scale-95 transition-transform duration-150"
          style={{
            height: '56px', borderRadius: '28px',
            background: 'linear-gradient(135deg, #3ECFA0, #2BA87F)',
            border: 'none', fontSize: '17px', fontWeight: 600, color: '#fff',
            cursor: 'pointer', boxShadow: '0 8px 24px rgba(62,207,160,0.35)',
          }}
        >
          Далее
        </button>
      </div>
    </div>
  );
}
